export enum MyPendingWorksComponentMode {
    MyPendingWorksComponentMode = 1,

}